import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'

// ✅ React 마운트 전 발생하는 전역 에러 캐치
window.addEventListener('error', (event) => {
  console.error('[Global Error]', event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Promise]', event.reason);
});

try {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');

  createRoot(rootEl).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
} catch (err) {
  console.error('[React Mount Error]', err);
  const rootEl = document.getElementById('root');
  if (rootEl) {
    rootEl.innerHTML = `
      <div style="min-height:100vh;background:linear-gradient(135deg,#0d1f3c,#152a52);display:flex;align-items:center;justify-content:center;padding:24px;">
        <div style="text-align:center;max-width:380px;">
          <div style="font-size:40px;margin-bottom:16px;">🏡</div>
          <div style="color:#c9a227;font-size:16px;font-weight:700;margin-bottom:8px;">홈 &amp; 그레이브</div>
          <p style="color:rgba(200,216,240,0.7);font-size:13px;line-height:1.6;margin-bottom:20px;">
            페이지를 불러오는 중 문제가 발생했습니다.<br/>새로고침 후 다시 시도해주세요.
          </p>
          <button onclick="window.location.reload()" style="padding:12px 28px;border-radius:12px;background:linear-gradient(135deg,#c9a227,#b8860b);color:#0d1f3c;font-weight:700;font-size:14px;border:none;cursor:pointer;">
            새로고침
          </button>
        </div>
      </div>
    `;
  }
}
